<template>

	<div class="bkf7 gameall_list">
		<el-container>
			<div class="inter2">

				<div class="filter_wbox">
					<div class="filter_wbox_list" v-if="!isMobile">
						<div class="item item_clear" @click="clearAllFilters" title="清空所有筛选条件">清空</div>
						<div class="item" :class="{ 'active': filter_chose[index].show_title != '' }"
							v-for="(item, index) in filterlist" @click="showfilter(index, item)">{{
								item.title }}</div>
					</div>
					<div class="filter_wbox_list filter_wbox_list-mobile" v-else>
						<div class="filter_wbox_list-scroll" v-if="!mobileFilterExpanded">
							<div class="item item_clear" @click="clearAllFilters" title="清空所有筛选条件">清空</div>
							<div class="item" :class="{ 'active': filter_chose[index].show_title != '' }"
								v-for="(item, index) in filterlist" :key="item.name" @click="showfilter(index, item)">{{
									item.title }}</div>
						</div>
						<div class="filter_wbox_list-full" v-else>
							<div class="item item_clear" @click="clearAllFilters" title="清空所有筛选条件">清空</div>
							<div class="item" :class="{ 'active': filter_chose[index].show_title != '' }"
								v-for="(item, index) in filterlist" :key="item.name" @click="showfilter(index, item)">{{
									item.title }}</div>
						</div>
						<div class="filter_wbox_list-expand" @click.stop="toggleMobileFilterExpand" title="展开/收起筛选">
							<i class="el-icon-s-fold" v-if="!mobileFilterExpanded"></i>
							<i class="el-icon-s-unfold" v-else></i>
						</div>
					</div>
					<div class="filter_wbox_content" :class="{ 'mobile-expanded': mobileFilterExpanded }"
						v-if="show_filter2 || mobileFilterExpanded">

						<div class="filter_wbox_list2" v-if="show_filter_content && show_filter_content.type != 'selects'">
							<div class="item" :class="{ 'active': getItemActive(show_filter_content, item) }"
								v-if="item.value != ''" v-for="(item, index) in show_filter_content.content"
								@click="choseFilterItem(show_filter_content, item)">

								{{ item.title }}
							</div>
							<div class="item item_btn confirm_btn" @click="confirmFilter">
								确定
							</div>
						</div>

						<div class="filter_wbox_list2" v-if="show_filter_content && show_filter_content.type == 'selects'">
							<div class="item"
								:class="{ 'active': show_filter_selects[show_filter_content.name] && show_filter_selects[show_filter_content.name].value.includes(item.value) }"
								v-if="item.value != ''" v-for="(item, index) in show_filter_content.content"
								@click="choseFilterselects(show_filter_content, item)">
								{{ item.title }}
							</div>
							<div class="item item_btn" @click="choseFilterItem2(show_filter_content)">
								确认
							</div>
						</div>
					</div>
					<div class="filter_wbox_select">
						<div class="filter_wbox_list3">
							<div class="item" v-if="item.show_title != ''" v-for="(item, index) in filter_chose"
								:key="index"
								v-show="!isMobile || ['chunbi', 'box', 'daopi', 'ganyuan'].includes(item.name)">

								<span class="sp1">{{ item.title }}:{{ item.show_title }}</span>
								<div class="ic" v-if="item.type != 'selects'">
									<i class="el-icon-circle-close" @click="removefilter(index)"></i>
								</div>
								<div class="ic" v-if="item.type == 'selects'">
									<i class="el-icon-circle-close" @click="removefilter2(index, item.name)"></i>
								</div>

							</div>
						</div>
					</div>
				</div>

				<div class="filter-content" style="margin-bottom: 20px;">
					<div class="filter-content-map">

						<!-- <div class="filter-list filter-script-list">
							<div class="filter-script">



								<div class="filter-item">
									<div class="filter-item-label">大区</div>
									<div class="filter-item-content">
										<div class="filter-item-options" style="height: auto;">

											<div class="opt-list">
												<div class="opt-item" @click="daquchange({ id: 0 })"
													:class="{ 'opt-item_active': 0 == daqu }">
													<div class="opt-item-name ellipsis-2">
														全部
													</div>
												</div>
												<div class="opt-item" @click="daquchange(item)"
													:class="{ 'opt-item_active': item.id == daqu }"
													v-for="item in channellist">
													<div class="opt-item-name ellipsis-2">
														{{ item.name }}
													</div>
												</div>
											</div>



										</div>
									</div>
								</div>


								<div class="filter-item" v-if="daqu != 0">
									<div class="filter-item-label">服务器</div>
									<div class="filter-item-content">
										<div class="filter-item-options" style="height: auto;">

											<div class="opt-list">
												<div class="opt-item" @click="fuwqichange({ id: 0 })"
													:class="{ 'opt-item_active': 0 == fuwuqi }">
													<div class="opt-item-name ellipsis-2">
														全部
													</div>
												</div>
												<div class="opt-item" @click="fuwqichange(item)"
													:class="{ 'opt-item_active': item.id == fuwuqi }"
													v-for="item in server_list">
													<div class="opt-item-name ellipsis-2">
														{{ item.name }}
													</div>
												</div>
											</div>



										</div>
									</div>
								</div>

								<div class="filter-item" v-if="show_filter" v-for="(item, index) in filterlist" :key="item.name" :class="{ 'mobile-filter-item': isMobile }" v-show="!isMobile || ['chunbi', 'box', 'daopi', 'ganyuan'].includes(item.name)">
									<div class="filter-item-label">{{ item.title }}</div>
									<div class="filter-item-content">
										<div class="filter-item-options"
											:class="{ 'filter-item-options_expand': show_list[item.name].show }">
											<div class="opt-list">
												<div class="opt-item" @click="choseFilter(index, item1.value)"
													:class="{ 'opt-item_active': item1.active }"
													v-for="item1 in item.content">
													<div class="opt-item-name ellipsis-2">
														{{ item1.title }}
													</div>
												</div>
											</div>

											<div class="opt-more"
												v-show="!show_list[item.name].show && show_list[item.name].extend == 'more'"
												@click="openShow(item.name)">
												更多
												<img :src="require(`@/assets/image/jiantou_n.png`)">
											</div>
											<div class="opt-more"
												v-show="show_list[item.name].show && show_list[item.name].extend == 'more'"
												@click="openShow(item.name)">
												收起
												<img :src="require(`@/assets/image/jiantou_n.png`)">
											</div>
										</div>
									</div>
								</div>
							</div>
						</div> -->

						
						<div class="publish-form" v-if="isAdmin && !hasBoundKefu">
							<el-form :model="publishForm" inline>
								<el-form-item label="选择客服" prop="kefu_id">
									<el-select v-model="publishForm.kefu_id" placeholder="请选择客服" style="width: 120px;"
										@change="handleKefuChange">
										<el-option v-for="item in activeKefuList" :key="item.id"
											:label="item.kefu_code + ' - ' + item.name" :value="item.id"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="游戏区服">
									<el-select v-model="publishForm.qufu" placeholder="游戏区服" style="width: 100px;">
										<el-option label="QQ" value="1"></el-option>
										<el-option label="微信" value="2"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="游戏等级">
									<el-input v-model="publishForm.level" placeholder="等级" style="width: 100px;"></el-input>
								</el-form-item>
								<el-form-item label="仓库总资产">
									<el-input v-model="publishForm.zichan" placeholder="仓库总资产" style="width: 120px;"></el-input>
								</el-form-item>
								<el-form-item label="纯币数量(M)">
									<el-input v-model="publishForm.chunbi" placeholder="纯币数量" style="width: 120px;"
										@input="calculateRent"></el-input>
								</el-form-item>
								<el-form-item label="段位">
									<el-select v-model="publishForm.duanwei" placeholder="段位" style="width: 100px;">
										<el-option label="无段位" value="1"></el-option>
										<el-option label="青铜" value="2"></el-option>
										<el-option label="白银" value="3"></el-option>
										<el-option label="黄金" value="4"></el-option>
										<el-option label="铂金" value="5"></el-option>
										<el-option label="钻石" value="6"></el-option>
										<el-option label="黑鹰" value="7"></el-option>
										<el-option label="三角洲巅峰" value="8"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="保险">
									<el-select v-model="publishForm.box" placeholder="保险" style="width: 100px;">
										<el-option label="2格" value="1"></el-option>
										<el-option label="4格" value="2"></el-option>
										<el-option label="6格" value="3"></el-option>
										<el-option label="9格" value="4"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="训练">
									<el-input type="number" v-model="publishForm.xunlian" placeholder="1-7"
										style="width: 100px;" min="1" max="7" @input="validateXunlianInput"></el-input>
								</el-form-item>
								<el-form-item label="靶场">
									<el-input type="number" v-model="publishForm.bachang" placeholder="1-7"
										style="width: 100px;" min="1" max="7" @input="validateBachangInput"></el-input>
								</el-form-item>
								<el-form-item label="登录方式">
									<el-select v-model="publishForm.login_type" placeholder="登录方式"
										style="width: 120px;">
										<el-option label="扫码登录" value="1"></el-option>
										<el-option label="账密登录" value="2"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="封禁记录">
									<el-select v-model="publishForm.is_feng" placeholder="封禁记录" style="width: 100px;">
										<el-option label="无" value="1"></el-option>
										<el-option label="有记录" value="2"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="本人人脸">
									<el-select v-model="publishForm.is_ben" placeholder="是否本人人脸" style="width: 120px;">
										<el-option label="是" value="1"></el-option>
										<el-option label="否" value="0"></el-option>
									</el-select>
								</el-form-item>
								
								<el-form-item label="干员皮">
									<el-select multiple v-model="publishForm.ganyuan" placeholder="干员皮"
										style="width: 180px;">
										<el-option label="红狼 - 蚀金玫瑰" value="1"></el-option>
										<el-option label="红狼 - 黑鹰坠落" value="2"></el-option>
										<el-option label="威龙 - 蛟龙行动" value="3"></el-option>
										<el-option label="威龙 - 铁面判官" value="4"></el-option>
										<el-option label="威龙 - 吴彦祖" value="5"></el-option>
										<el-option label="蜂医 - 送葬人" value="6"></el-option>
										<el-option label="蜂医 - 黑鹰坠落" value="7"></el-option>
										<el-option label="蜂医 - 危险物质" value="8"></el-option>
										<el-option label="无名 - 夜鹰" value="9"></el-option>
										<el-option label="乌鲁售・黑鹰坠落" value="10"></el-option>
										<el-option label="牧羊人 - 黑鹰坠落" value="11"></el-option>
										<el-option label="牧羊人 - 街头之王" value="12"></el-option>
										<el-option label="露娜 - 黑 - 天际线" value="13"></el-option>
										<el-option label="蛊 - 能天使 - 午夜邮差" value="14"></el-option>
										<el-option label="骇爪 - 维什戴尔" value="15"></el-option>
										<el-option label="骇爪 - 水墨云图" value="16"></el-option>
										<el-option label="露娜 - 金牌射手" value="17"></el-option>
										<el-option label="深蓝 - 不破之誓" value="18"></el-option>
										<el-option label="红狼 - 电锯惊魂" value="19"></el-option>
										<el-option label="威龙 - 凌霄戍卫" value="20"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="刀皮">
									<el-select multiple v-model="publishForm.daopi" placeholder="刀皮"
										style="width: 180px;">
										<el-option label="信条" value="1"></el-option>
										<el-option label="赤霄" value="2"></el-option>
										<el-option label="怜悯" value="3"></el-option>
										<el-option label="影锋" value="4"></el-option>
										<el-option label="黑海" value="5"></el-option>
										<el-option label="北极星" value="6"></el-option>
										<el-option label="电锯惊魂" value="7"></el-option>
										<el-option label="龙牙" value="8"></el-option>
										<el-option label="暗星" value="9"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="武器皮">
									<el-select multiple v-model="publishForm.wuqi" placeholder="武器皮"
										style="width: 200px;">
										<el-option label="M7 棱镜攻势" value="1"></el-option>
										<el-option label="M4 棱镜攻势" value="2"></el-option>
										<el-option label="K416 - 命运" value="3"></el-option>
										<el-option label="SCAR - 电玩" value="4"></el-option>
										<el-option label="腾龙 - 气象感应" value="5"></el-option>
										<el-option label="QBZ95 - 王牌之剑" value="6"></el-option>
										<el-option label="Vctor - 中锋枪 - 美杜莎" value="7"></el-option>
										<el-option label="AS Val 突击步枪 - 悬赏令" value="8"></el-option>
										<el-option label="AUG - 气象感应" value="9"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="AWM子弹">
									<el-input v-model="publishForm.awm" placeholder="AWM子弹"
										style="width: 100px;"></el-input>
								</el-form-item>
								<el-form-item label="六套数量">
									<el-input v-model="publishForm.liutao" placeholder="0-60"
										style="width: 100px;"></el-input>
								</el-form-item>
								<el-form-item label="比例">
									<el-input v-model="publishForm.bili" placeholder="比例" style="width: 80px;"
										@input="calculateRent"></el-input>
								</el-form-item>
								<el-form-item label="价格(元)">
									<el-input v-model="publishForm.price" placeholder="租金"
										style="width: 100px;"></el-input>
								</el-form-item>
								<el-form-item label="押金(元)">
									<el-input v-model="publishForm.yajin" placeholder="押金"
										style="width: 100px;"></el-input>
								</el-form-item>
								<el-form-item label="IP地址">
									<el-input v-model="publishForm.changzhu" placeholder="IP地址" style="width: 150px;"></el-input>
								</el-form-item>
								<el-form-item label="KD">
									<el-input v-model="publishForm.kd" placeholder="kd" style="width: 80px;"></el-input>
								</el-form-item>
								<el-form-item label="租期(天)">
									<el-input v-model="publishForm.zuqi" placeholder="租期" style="width: 100px;"
										@input="calculateRent"></el-input>
									<span style="margin-left: 5px; color: #999;">(自动:纯币/10)</span>
								</el-form-item>
								<el-form-item label="备注">
									<el-input v-model="publishForm.beizhu" placeholder="备注"
										style="width: 150px;"></el-input>
								</el-form-item>
								<el-form-item>
									<el-button type="primary"
										style="background: #1f9535; border-color: #1f9535; color: #fff; border-radius: 5px; padding: 10px 20px;"
										@click="publishAccount">发布账号</el-button>
								</el-form-item>
							</el-form>
						</div>
						<div class="filter-keywords-search">

							<div class="filter-search-info "
								style="display: flex; justify-content: start;margin-bottom: 10px;">
								<div class="filter-search-label" style="margin-right: 10px;">关键词</div>
								<div class="filter-search-input el-input el-input--suffix">
									<input type="text" autocomplete="off" v-model="keyword" placeholder="请输入关键字"
										class="el-input__inner"><span class="el-input__suffix">
										<span class="el-input__suffix-inner" @click="Search">
											<div class="search">搜索</div>
										</span></span>
								</div>
							</div>
						</div>
					</div>
				</div>


				<el-row>
					<div class="sortpaixu">
						<ul class="sortpaixu_ul">
							<!-- <li v-if="!isMobile" :class="{ 'active': sortactive == 1 }" @click="chose_sort(1)"><span>推荐排序</span></li> -->
							<!-- <li v-if="isMobile" :class="{ 'active': sortactive == 1 }" @click="chose_sort(1)"><span>默认</span></li> -->
							<li :class="{ 'active': sortactive == 5 }" @click="chose_sort(5, sort)">
								<span>比例</span><span v-if="sortactive == 5 && sort == 0">↑</span><span
									v-if="sortactive == 5 && sort == 1">↓</span>
							</li>
							<li :class="{ 'active': sortactive == 2 }" @click="chose_sort(2, sort)">
								<span>租金</span><span v-if="sortactive == 2 && sort == 0">↑</span><span
									v-if="sortactive == 2 && sort == 1">↓</span>
							</li>
							<li :class="{ 'active': sortactive == 3 }" @click="chose_sort(3, sort)">
								<span>押金</span><span v-if="sortactive == 3 && sort == 0">↑</span><span
									v-if="sortactive == 3 && sort == 1">↓</span>
							</li>
							<li :class="{ 'active': sortactive == 4 }" @click="chose_sort(4, sort)">
								<span>纯币</span><span v-if="sortactive == 4 && sort == 0">↑</span><span
									v-if="sortactive == 4 && sort == 1">↓</span>
							</li>
							<template v-if="isMobile">
								<li class="mobile-special-filter" style="margin-left: 12px;">
									<span :class="{ 'active': showNightShift }" @click="toggleNightShift">
										夜班号表
									</span>
								</li>
								<li class="mobile-special-filter">
									<span :class="{ 'active': showADCode }" @click="toggleADCode">
										AD编号
									</span>
								</li>
								<li class="mobile-special-filter">
									<span :class="{ 'active': showBHCode }" @click="toggleBHCode">
										BH编号
									</span>
								</li>
							</template>
							<template v-else>
								<li v-if="isAdmin" style="margin-left: 15px; display: flex; align-items: center;">
									<el-checkbox v-model="showCompactView" :disabled="windowWidth >= 1400">
										简化列表
										<el-tooltip content="只有在页面宽度小于1400px时会简化列表" placement="top">
											<i class="el-icon-question" style="margin-left: 3px; color: #409EFF;"></i>
										</el-tooltip>
									</el-checkbox>
								</li>
								<li style="margin-left: 15px; display: flex; align-items: center;">
									<el-checkbox v-model="showNightShift">
										夜班号表
									</el-checkbox>
								</li>
								<li style="margin-left: 15px; display: flex; align-items: center;">
									<el-checkbox v-model="showADCode">
										AD编号
									</el-checkbox>
								</li>
								<li style="margin-left: 15px; display: flex; align-items: center;">
									<el-checkbox v-model="showBHCode">
										BH编号
									</el-checkbox>
								</li>
							</template>
						</ul>


					</div>
				</el-row>



				<el-row v-if="isMobile">


					<div class="mobile_home_game" :key="mo_index">
						<div class="item" v-for="(item, index) in flowList" @click="goToDetail(item)">
							<div class="w_con1">
								<div class="wtext_1">
									<div class="image">
										<img src="@/assets/image/tu_biao.png" />
									</div>
									<div class="text">
										<p class="p1" :class="getTimeClass(item)">{{ item.account_no || item.id }}<span v-if="isNightShiftAccount(item)" style="margin-left: 4px;">🌙</span></p>
										<p class="p2"> 编号：{{ item.account_no || item.id }}<span v-if="isNightShiftAccount(item)" style="margin-left: 4px;">🌙</span> </p>
										<div class="p3">
											<div class="price1">
												<span class="sp1">￥</span>
												<span class="sp2">{{ item.price }}</span>
												<span class="sp3">租金</span>
											</div>
											<div class="price2">
												<span class="sp1">￥</span>
												<span class="sp2">{{ item.yajin }}</span>
												<span class="sp3">押金</span>
											</div>
											<div class="price3">
												<span class="sp2">{{ item.zuqi || '-' }}</span>
												<span class="sp2" style="font-size: 12px;">天</span>
												<span class="sp3">租期</span>
											</div>
										</div>
									</div>
								</div>
								<div class="wtext_2">
									<div class="text">
										<p class="p1" :title="getFilterNameList('daopi', item.daopi)">
											{{ getFilterNameList('daopi', item.daopi) || '-' }}</p>
										<p class="p2">刀皮</p>
									</div>

									<div class="text">
										<p class="p1">{{ item.chunbi }}</p>
										<p class="p2">纯币资产(m)</p>
									</div>
									<div class="text">
										<p class="p1">{{ getFilterName('box', item.box) }}</p>
										<p class="p2">安全箱</p>
									</div>
									<div class="text">
										<p class="p1">{{ item.awm }}</p>
										<p class="p2">AWM子弹</p>
									</div>
								</div>
								<div class="wtext_2_5">
									<div class="text">
										<p class="p1">{{ item.xunlian || '-' }}级</p>
										<p class="p2">训练等级</p>
									</div>
									<div class="text">
										<p class="p1">{{ item.bachang || '-' }}级</p>
										<p class="p2">靶场等级</p>
									</div>
									<div class="text">
										<p class="p1">{{ item.login_type == '1' ? '扫码' : (item.login_type == '2' ? '密码' : '-') }}</p>
										<p class="p2">常用登录</p>
									</div>
									<div class="text">
										<p class="p1">{{ item.liutao || '-' }}</p>
										<p class="p2">六套数量</p>
									</div>
								</div>
								<div class="wtext_3">

									<div class="fl" @click.stop="show(index)">
										账号详情 <div class="ic">

											<i class="el-icon-arrow-down" v-if="!item.show"></i>
											<i class="el-icon-arrow-up" v-if="item.show"></i>
										</div>
									</div>
									<div class="fr" :style="isMobile ? '' : 'display: none;'">
										<template v-if="isAdmin">
											<el-button size="mini"
												style="background: #1f9535; border-color: #1f9535; color: #fff; border-radius: 3px;"
												@click.stop="editAccount(item)">修改</el-button>
											<el-button v-if="!hasBoundKefu || isBoundKefu(item.account_no)" size="mini"
												style="background: #ff4d4f; border-color: #ff4d4f; color: #fff; border-radius: 3px;"
												@click.stop="deleteAccount(item.id)">删除</el-button>
											<el-button v-if="!hasBoundKefu || isBoundKefu(item.account_no)" size="mini"
												style="background: #faad14; border-color: #faad14; color: #fff; border-radius: 3px;"
												@click.stop="suspendAccount(item.id)">下架</el-button>
										</template>
										<template v-else>
											<el-button size="mini"
												style="background: #1f9535; border-color: #1f9535; color: #fff; border-radius: 3px;"
												@click.stop="openKefuDialog(item)">立即租赁</el-button>
										</template>
									</div>
								</div>
							</div>
							<div class="item-view-bottom-details" v-show="item.show">
								<div class="detail-series type1"> 游戏区服:{{ item.qufu == '2' ? '微信' : item.qufu == '1' ?
									'QQ' : '-' }} </div>
								<div class="detail-series type2"> 登录方式：{{ item.login_type == '1' ? '扫码登录' :
									item.login_type == '2' ?
										'账号密码' : '-' }} </div>
								<div class="detail-series type3">段位：{{ getFilterName('duanwei', item.duanwei) }}</div>
								<div class="detail-series">纯币资产：{{ item.chunbi }}M</div>
								<div class="detail-series">比例：{{ item.bili }}</div>
								<div class="detail-series">账号等级：{{ item.level }}</div>
								<div class="detail-series">靶场等级：{{ item.bachang }}级</div>
								<div class="detail-series">训练等级：{{ item.xunlian }}级</div>
								<div class="detail-series"> 封禁记录：{{ item.is_feng == '1' ? '无' : item.is_feng == '2' ?
									'有' : '-' }} </div>
								<div class="detail-series"> 人脸是否本人：{{ item.is_ben == '1' ? '是' : item.is_ben == '2' ?
									'否' : '-' }} </div>
								<div class="detail-series">常用登陆地：{{ getFilterName('changzhu', item.changzhu) || item.changzhu }}</div>
								<div class="detail-series"> 账号类型：{{ item.leixing == '1' ? '纯币号' : item.leixing == '2' ?
									'纯币+物资' : '-' }} </div>
								<div class="detail-series">持有刀皮：{{ getFilterNameList('daopi', item.daopi)
								}}</div>
								<div class="detail-series">干员外观：{{ getFilterNameList('ganyuan', item.ganyuan)
								}}</div>
								<div class="detail-series">六套数量：{{ item.liutao || '-' }}</div>
								<div class="detail-series" v-if="item.beizhu" style="width: 100%; white-space: normal;">
									备注：{{ item.beizhu }}</div>
							</div>
						</div>

					</div>
					<el-pagination class="pagebox" v-if="isMobile" background
						@current-change="handleCurrentChange" :current-page="current_page"
						:page-size="pagesize"
						layout="total, prev, next" :total="total">
					</el-pagination>
					<div v-if="isMobile" class="mobile-icp-info">
						<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">鄂ICP备2025150633号</a>
						<span>-</span>
						<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">鄂ICP备2025150633号-5</a>
					</div>
					<el-pagination class="pagebox" v-else background @size-change="handleSizeChange"
						@current-change="handleCurrentChange" :current-page="current_page"
						:page-sizes="[20, 30, 50, 100]" :page-size="20" layout="total, sizes, prev, pager, next, jumper"
						:total="total">
					</el-pagination>
				</el-row>


				<div class="zh_wcontent">
					<el-row v-if="!isMobile">


						<div v-show="loading" style="padding: 20px;" v-loading="loading" element-loading-text="加载中"
							element-loading-spinner="el-icon-loading">
							<el-skeleton :rows="6" animated />
						</div>

						<div class="my-table" v-if="!loading">
							<!-- 管理员且宽度<1400时的简化表格 -->
							<el-table v-if="isCompactView" :data="flowList" style="width: 100%" @row-click="goToDetail" :cell-class-name="getCellClassName" :cell-style="cellStyle">
								<!-- 编号 -->
								<el-table-column fixed="left" prop="account_no" label="编号" width="100" >
									<template slot="header">
										<span>编号</span>
										<el-tooltip content="蓝色:24小时内更新|黄色:72小时内更新|橙色:7天内更新" placement="top">
											<i class="el-icon-question" style="margin-left:5px;color:#45F4A9"></i>
										</el-tooltip>
									</template>
									<template slot-scope="scope" >
										<span @click.stop="copyAccountNo(scope.row.account_no || scope.row.id)">{{ scope.row.account_no || scope.row.id }}</span>
										<span v-if="isNightShiftAccount(scope.row)" style="margin-left: 4px;">🌙</span>
									</template>
								</el-table-column>
								<!-- 夜班 -->
								<!-- <el-table-column v-if="!isMobile" align="center" label="夜班" width="60">
									<template slot-scope="scope">
										<span v-if="isNightShiftAccount(scope.row)">🌙</span>
										<span v-else>-</span>
									</template>
								</el-table-column> -->
								<!-- 登录方式 -->
								<el-table-column align="center" width="90px" prop="login_type" label="登录方式">
									<template slot-scope="scope">
										<span
											:class="scope.row.login_type === '1' ? 'color-sm color-div' : 'color-qq color-div'">
											{{ scope.row.login_type == '1' ? '扫码' : scope.row.login_type == '2' ?
          '账号' : '-' }}
										</span>
									</template>
								</el-table-column>
								<!-- 纯币资产 -->
								<el-table-column align="center" width="80px" prop="chunbi" label="纯币(m)">
								</el-table-column>
								<!-- 安全箱 -->
								<el-table-column align="center" min-width="140px" prop="box" label="安全箱">
									<template slot-scope="scope">
										<span class="color-sm color-div" :class="['color-div_box' + scope.row.box]">
											{{ getFilterName('box', scope.row.box) }}
										</span>
									</template>
								</el-table-column>
								<!-- 训练等级 -->
								<el-table-column align="center" prop="xunlian" label="训练" min-width="60">
									<template slot-scope="scope">
										<span>{{ scope.row.xunlian }}级</span>
									</template>
								</el-table-column>
								<!-- 靶场等级 -->
								<el-table-column align="center" prop="bachang" label="靶场" min-width="60">
									<template slot-scope="scope">
										<span>{{ scope.row.bachang }}级</span>
									</template>
								</el-table-column>
								<!-- 段位 -->
								<el-table-column align="center" prop="duanwei" label="段位" width="120">
									<template slot-scope="scope">
										<span :class="'duanwei-tag duanwei-' + scope.row.duanwei">
											{{ getFilterName('duanwei', scope.row.duanwei) }}
										</span>
									</template>
								</el-table-column>
								<!-- awm -->
								<el-table-column align="center" min-width="60px" prop="awm" label="AWM">
								</el-table-column>
								<!-- 六套 -->
								<el-table-column align="center" prop="liutao" label="六套" width="50">
								</el-table-column>
								<!-- 比例 -->
								<el-table-column align="center" prop="bili" label="比例" width="60">
								</el-table-column>
								<!-- 价格 -->
								<el-table-column align="center" prop="price" label="价格" min-width="70">
								</el-table-column>
								<!-- 押金 -->
								<el-table-column align="center" prop="yajin" label="押金" min-width="70">
								</el-table-column>
																<!-- 刀皮 -->
								<el-table-column align="center" prop="daopi" label="刀皮" min-width="100">
									<template slot-scope="scope">
										<div class="text-expand-box" @click.stop>
											<template v-if="expandState[scope.row.id + '_daopi']">
												<span class="sp_text sp_text-expanded">{{ getFilterNameList('daopi', scope.row.daopi) }}</span>
											</template>
											<template v-else>
												<el-tooltip class="item" effect="dark" :content="getFilterNameList('daopi', scope.row.daopi)" placement="left">
													<span class="sp_text ellipsis-text">{{ getFilterNameList('daopi', scope.row.daopi) }}</span>
												</el-tooltip>
											</template>
											<span v-if="getFilterNameList('daopi', scope.row.daopi) && getFilterNameList('daopi', scope.row.daopi).length > 6" class="expand-btn" @click.stop="toggleExpand(scope.row.id, 'daopi')">
												<i class="el-icon-arrow-up" v-if="expandState[scope.row.id + '_daopi']"></i>
												<i class="el-icon-arrow-down" v-else></i>
											</span>
										</div>
									</template>
								</el-table-column>
								<!-- 干员皮 -->
								<el-table-column align="center" prop="ganyuan" label="干员皮" min-width="100">
									<template slot-scope="scope">
										<div class="text-expand-box" @click.stop>
											<template v-if="expandState[scope.row.id + '_ganyuan']">
												<span class="sp_text sp_text-expanded">{{ getFilterNameList('ganyuan', scope.row.ganyuan) }}</span>
											</template>
											<template v-else>
												<el-tooltip class="item" effect="dark" :content="getFilterNameList('ganyuan', scope.row.ganyuan)" placement="left">
													<span class="sp_text ellipsis-text">{{ getFilterNameList('ganyuan', scope.row.ganyuan) }}</span>
												</el-tooltip>
											</template>
											<span v-if="getFilterNameList('ganyuan', scope.row.ganyuan) && getFilterNameList('ganyuan', scope.row.ganyuan).length > 6" class="expand-btn" @click.stop="toggleExpand(scope.row.id, 'ganyuan')">
												<i class="el-icon-arrow-up" v-if="expandState[scope.row.id + '_ganyuan']"></i>
												<i class="el-icon-arrow-down" v-else></i>
											</span>
										</div>
									</template>
								</el-table-column>

								<!-- 租期 -->
								<el-table-column align="center" prop="zuqi" label="租期" min-width="60">
									<template slot-scope="scope">
										<span>{{ scope.row.zuqi || '-' }}</span>
									</template>
								</el-table-column>
								<!-- 备注 -->
								<el-table-column align="center" prop="beizhu" label="备注" min-width="120">
									<template slot-scope="scope">
										<el-tooltip class="item" effect="dark" :content="scope.row.beizhu" placement="left">
											<span class="sp_text"> {{ scope.row.beizhu }}</span>
										</el-tooltip>
									</template>
								</el-table-column>
								<!-- 操作列 -->
								<el-table-column v-if="isMobile" align="center" fixed="right" min-width="180px" label="操作">
									<template slot-scope="scope">
										<div class="order-btn-box">
											<template v-if="isAdmin">
												<el-button size="mini"
													style="background: #1f9535; border-color: #1f9535; color: #fff; border-radius: 3px;"
													@click.stop="editAccount(scope.row)">修改</el-button>
												<el-button v-if="!hasBoundKefu || isBoundKefu(scope.row.account_no)" size="mini"
													style="background: #ff4d4f; border-color: #ff4d4f; color: #fff; border-radius: 3px;"
													@click.stop="deleteAccount(scope.row.id)">删除</el-button>
												<el-button v-if="!hasBoundKefu || isBoundKefu(scope.row.account_no)" size="mini"
													style="background: #faad14; border-color: #faad14; color: #fff; border-radius: 3px;"
													@click.stop="suspendAccount(scope.row.id)">下架</el-button>
											</template>
											<template v-else>
												<el-button size="mini"
													style="background: #1f9535; border-color: #1f9535; color: #fff; border-radius: 3px;"
													@click.stop="openKefuDialog(scope.row)">下单</el-button>
											</template>
										</div>
									</template>
								</el-table-column>
							</el-table>
							<!-- 正常宽度或非管理员时的完整表格 -->
							<el-table v-else :data="flowList" style="width: 100%" @row-click="goToDetail" :cell-class-name="getCellClassName" :cell-style="cellStyle">
								<!-- 编号 -->
								<el-table-column fixed="left" prop="account_no" label="编号" width="110" >
									<template slot="header">
										<span>编号</span>
										<el-tooltip content="蓝色:24小时内更新|黄色:72小时内更新|橙色:7天内更新" placement="top">
											<i class="el-icon-question" style="margin-left:5px;color:#45F4A9"></i>
										</el-tooltip>
									</template>
									<template slot-scope="scope" >
										<span @click.stop="copyAccountNo(scope.row.account_no || scope.row.id)">{{ scope.row.account_no || scope.row.id }}</span>
										<span v-if="isNightShiftAccount(scope.row)" style="margin-left: 4px;">🌙</span>
									</template>
								</el-table-column>
								<!-- 区服 -->
								<el-table-column prop="qufu" label="区服" width="70">
									<template slot-scope="scope">
										<span
											:class="scope.row.qufu === '2' ? 'color-wechat color-div' : 'color-qq color-div'">
											{{ scope.row.qufu == '2' ? '微信' : scope.row.qufu == '1' ? 'QQ' : '-' }}
										</span>
									</template>
								</el-table-column>
								<!-- 登录方式 -->
								<el-table-column align="center" width="100px" prop="login_type" label="登录方式">
									<template slot-scope="scope">
										<span
											:class="scope.row.login_type === '1' ? 'color-sm color-div' : 'color-qq color-div'">
											{{ scope.row.login_type == '1' ? '扫码登录' : scope.row.login_type == '2' ?
          '账号密码' : '-' }}
										</span>
									</template>
								</el-table-column>
								<!-- 纯币资产 -->
								<el-table-column align="center" width="90px" prop="chunbi" label="纯币(m)">
									<template slot="header">
										<span>纯币(m)</span>
										<el-tooltip content="纯币资产单位 1M=100万" placement="top">
											<i class="el-icon-question" style="margin-left:5px;color:#45F4A9"></i>
										</el-tooltip>
									</template>
								</el-table-column>
								<!-- 安全箱 -->
								<el-table-column align="center" min-width="140px" prop="box" label="安全箱">
									<template slot-scope="scope">
										<span class="color-sm color-div" :class="['color-div_box' + scope.row.box]">
											{{ getFilterName('box', scope.row.box) }}
										</span>
									</template>
								</el-table-column>
								<!-- 训练等级 -->
								<el-table-column align="center" prop="xunlian" label="训练" min-width="70">
									<template slot-scope="scope">
										<span>
											{{ scope.row.xunlian }}级
										</span>
									</template>
								</el-table-column>
								<!-- 靶场等级 -->
								<el-table-column align="center" prop="bachang" label="靶场" min-width="70">
									<template slot-scope="scope">
										<span>
											{{ scope.row.bachang }}级
										</span>
									</template>
								</el-table-column>
								<!-- 段位 -->
								<el-table-column align="center" prop="duanwei" label="段位" width="120">
									<template slot-scope="scope">
										<span :class="'duanwei-tag duanwei-' + scope.row.duanwei">
											{{ getFilterName('duanwei', scope.row.duanwei) }}
										</span>
									</template>
								</el-table-column>
								<!-- aw -->
								<el-table-column align="center" min-width="70px" prop="awm" label="AWM">
								</el-table-column>
								<!-- 六套 -->
								<el-table-column align="center" prop="liutao" label="六套" width="70">
								</el-table-column>
																<!-- 刀皮 -->
								<el-table-column align="center" prop="daopi" label="刀皮" min-width="120">
									<template slot-scope="scope">
										<div class="text-expand-box" @click.stop>
											<template v-if="expandState[scope.row.id + '_daopi']">
												<span
													class="sp_text sp_text-expanded">{{ getFilterNameList('daopi', scope.row.daopi) }}</span>
											</template>
											<template v-else>
												<el-tooltip class="item" effect="dark"
													:content="getFilterNameList('daopi', scope.row.daopi)"
													placement="left">
													<span
														class="sp_text ellipsis-text">{{ getFilterNameList('daopi', scope.row.daopi) }}</span>
												</el-tooltip>
											</template>
											<span
												v-if="getFilterNameList('daopi', scope.row.daopi) && getFilterNameList('daopi', scope.row.daopi).length > 8"
												class="expand-btn" @click.stop="toggleExpand(scope.row.id, 'daopi')">
												<i class="el-icon-arrow-up"
													v-if="expandState[scope.row.id + '_daopi']"></i>
												<i class="el-icon-arrow-down" v-else></i>
											</span>
										</div>
									</template>
								</el-table-column>
								<!-- 干员皮 -->
								<el-table-column align="center" prop="ganyuan" label="干员皮" min-width="120">
									<template slot-scope="scope">
										<div class="text-expand-box" @click.stop>
											<template v-if="expandState[scope.row.id + '_ganyuan']">
												<span
													class="sp_text sp_text-expanded">{{ getFilterNameList('ganyuan', scope.row.ganyuan) }}</span>
											</template>
											<template v-else>
												<el-tooltip class="item" effect="dark"
													:content="getFilterNameList('ganyuan', scope.row.ganyuan)"
													placement="left">
													<span
														class="sp_text ellipsis-text">{{ getFilterNameList('ganyuan', scope.row.ganyuan) }}</span>
												</el-tooltip>
											</template>
											<span
												v-if="getFilterNameList('ganyuan', scope.row.ganyuan) && getFilterNameList('ganyuan', scope.row.ganyuan).length > 8"
												class="expand-btn" @click.stop="toggleExpand(scope.row.id, 'ganyuan')">
												<i class="el-icon-arrow-up"
													v-if="expandState[scope.row.id + '_ganyuan']"></i>
												<i class="el-icon-arrow-down" v-else></i>
											</span>
										</div>
									</template>
								</el-table-column>

								<!-- 武器皮 -->
								<el-table-column align="center" prop="wuqi" label="武器皮" min-width="120">
									<template slot-scope="scope">
										<div class="text-expand-box" @click.stop>
											<template v-if="expandState[scope.row.id + '_wuqi']">
												<span
													class="sp_text sp_text-expanded">{{ getFilterNameList('wuqi', scope.row.wuqi) }}</span>
											</template>
											<template v-else>
												<el-tooltip class="item" effect="dark"
													:content="getFilterNameList('wuqi', scope.row.wuqi)"
													placement="left">
													<span
														class="sp_text ellipsis-text">{{ getFilterNameList('wuqi', scope.row.wuqi) }}</span>
												</el-tooltip>
											</template>
											<span
												v-if="getFilterNameList('wuqi', scope.row.wuqi) && getFilterNameList('wuqi', scope.row.wuqi).length > 8"
												class="expand-btn" @click.stop="toggleExpand(scope.row.id, 'wuqi')">
												<i class="el-icon-arrow-up"
													v-if="expandState[scope.row.id + '_wuqi']"></i>
												<i class="el-icon-arrow-down" v-else></i>
											</span>
										</div>
									</template>
								</el-table-column>
								<!-- 比例 -->
								<el-table-column align="center" prop="bili" label="比例" width="70">
									<template slot="header">
										<span>比例</span>
										<el-tooltip content="以1：40为例，表示1元=40万哈夫币" placement="top">
											<i class="el-icon-question" style="margin-left:5px;color:#45F4A9"></i>
										</el-tooltip>
									</template>
								</el-table-column>
								<!-- 价格 -->
								<el-table-column align="center" prop="price" label="价格(元)" min-width="80">
								</el-table-column>
								<!-- 押金 -->
								<el-table-column align="center" prop="yajin" label="押金(元)" min-width="80">
								</el-table-column>
								<!-- 租期 -->
								<el-table-column align="center" prop="zuqi" label="租期(天)" min-width="80">
									<template slot-scope="scope">
										<span>{{ scope.row.zuqi || '-' }}</span>
									</template>
								</el-table-column>

								<!-- 以下为原有保留字段，未做任何修改 -->
								<el-table-column align="center" prop="kd" label="KD" min-width="60">
									<template slot-scope="scope">
										<span>{{ scope.row.kd || '-' }}</span>
									</template>
								</el-table-column>
								<el-table-column align="center" prop="beizhu" label="备注" min-width="180">
									<template slot-scope="scope">
										<el-tooltip class="item" effect="dark" :content="scope.row.beizhu"
											placement="left">
											<span class="sp_text"> {{ scope.row.beizhu }}</span>
										</el-tooltip>
									</template>
								</el-table-column>

								<!-- 操作列 -->
								<el-table-column v-if="isMobile" align="center" fixed="right" min-width="180px" label="操作">
									<template slot-scope="scope">
										<div class="order-btn-box">
											<template v-if="isAdmin">
												<el-button size="mini"
													style="background: #1f9535; border-color: #1f9535; color: #fff; border-radius: 3px;"
													@click.stop="editAccount(scope.row)">修改</el-button>
												<el-button size="mini"
													style="background: #ff4d4f; border-color: #ff4d4f; color: #fff; border-radius: 3px;"
													@click.stop="deleteAccount(scope.row.id)">删除</el-button>
												<el-button size="mini"
													style="background: #faad14; border-color: #faad14; color: #fff; border-radius: 3px;"
													@click.stop="suspendAccount(scope.row.id)">下架</el-button>
											</template>
											<template v-else>
												<el-button size="mini"
													style="background: #1f9535; border-color: #1f9535; color: #fff; border-radius: 3px;"
													@click.stop="openKefuDialog(scope.row)">下单</el-button>
											</template>
										</div>
									</template>
								</el-table-column>
							</el-table>
						</div>





						<el-pagination class="pagebox" background @size-change="handleSizeChange"
							@current-change="handleCurrentChange" :current-page="current_page"
							:page-sizes="[20, 30, 50, 100]" :page-size="20"
							layout="total, sizes, prev, pager, next, jumper" :total="total">
						</el-pagination>

					</el-row>
				</div>
			</div>
		</el-container>
		<el-dialog :visible.sync="image_show" :center="true" width="500px" destroy-on-close @closed="visible3 = false">
			<div class="image_show_box">
				<img :src="img_src">
			</div>
		</el-dialog>
		<el-dialog title="联系客服下单" :visible.sync="kefuDialogVisible" width="400px" :close-on-click-modal="true"
			:close-on-press-escape="true" :show-close="true" destroy-on-close>
			<div style="text-align: center; padding: 20px;">
				<div style="font-size: 24px; font-weight: bold; margin-bottom: 20px; color: #E6A23C;">
					{{ currentAccountNo || '暂无编号' }}
				</div>
				<div v-if="currentKefuInfo && currentKefuInfo.qrcode" style="margin-bottom: 20px;">
					<img :src="fixImageUrl(currentKefuInfo.qrcode)"
						style="width: 200px; height: 200px; object-fit: contain;" />
				</div>
				<div style="font-size: 16px; margin-bottom: 10px;">
					客服姓名：{{ currentKefuInfo ? currentKefuInfo.name : '-' }}
				</div>
				<div style="font-size: 16px; margin-bottom: 10px;">
					微信号：{{ currentKefuInfo ? currentKefuInfo.wechat : '-' }}
				</div>
				<div style="font-size: 14px; color: #909399; margin-top: 20px;">
					请扫码添加客服微信或搜索微信号添加
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="closeKefuDialog">关闭</el-button>
			</span>
		</el-dialog>
		<el-dialog title="编辑账号" :visible.sync="dialogVisible" width="900px" top="5vh">
			<el-form :model="form" label-width="100px">
				<el-row :gutter="20">
					<el-col :span="8">
						<el-form-item label="选择客服">
							<el-select v-model="form.kefu_id" placeholder="请选择客服" style="width: 100%;">
								<el-option v-for="item in activeKefuList" :key="item.id"
									:label="item.kefu_code + ' - ' + item.name" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="游戏区服">
							<el-select v-model="form.qufu" placeholder="游戏区服" style="width: 100%;">
								<el-option label="QQ" value="1"></el-option>
								<el-option label="微信" value="2"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="仓库总资产">
							<el-input v-model="form.zichan" placeholder="仓库总资产" style="width: 100%;"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :span="8">
						<el-form-item label="纯币数量(M)">
							<el-input v-model="form.chunbi" placeholder="纯币数量" style="width: 100%;" @input="calculateEditPrice('chunbi')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="段位">
							<el-select v-model="form.duanwei" placeholder="段位" style="width: 100%;">
								<el-option label="无段位" value="1"></el-option>
								<el-option label="青铜" value="2"></el-option>
								<el-option label="白银" value="3"></el-option>
								<el-option label="黄金" value="4"></el-option>
								<el-option label="铂金" value="5"></el-option>
								<el-option label="钻石" value="6"></el-option>
								<el-option label="黑鹰" value="7"></el-option>
								<el-option label="三角洲巅峰" value="8"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="保险">
							<el-select v-model="form.box" placeholder="保险" style="width: 100%;">
								<el-option label="2格" value="1"></el-option>
								<el-option label="4格" value="2"></el-option>
								<el-option label="6格" value="3"></el-option>
								<el-option label="9格" value="4"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :span="8">
						<el-form-item label="训练">
							<el-input type="number" v-model="form.xunlian" placeholder="1-7" style="width: 100%;"
								min="1" max="7"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="靶场">
							<el-input type="number" v-model="form.bachang" placeholder="1-7" style="width: 100%;"
								min="1" max="7"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="登录方式">
							<el-select v-model="form.login_type" placeholder="登录方式" style="width: 100%;">
								<el-option label="扫码登录" value="1"></el-option>
								<el-option label="账密登录" value="2"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :span="8">
						<el-form-item label="封禁记录">
							<el-select v-model="form.is_feng" placeholder="封禁记录" style="width: 100%;">
								<el-option label="无" value="1"></el-option>
								<el-option label="有记录" value="2"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="本人人脸">
							<el-select v-model="form.is_ben" placeholder="是否本人人脸" style="width: 100%;">
								<el-option label="是" value="1"></el-option>
								<el-option label="否" value="0"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="游戏等级">
							<el-input v-model="form.level" placeholder="等级" style="width: 100%;"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :span="24">
						<el-form-item label="干员皮">
							<el-select multiple v-model="form.ganyuan" placeholder="干员皮" style="width: 100%;">
								<el-option label="红狼 - 蚀金玫瑰" value="1"></el-option>
								<el-option label="红狼 - 黑鹰坠落" value="2"></el-option>
								<el-option label="威龙 - 蛟龙行动" value="3"></el-option>
								<el-option label="威龙 - 铁面判官" value="4"></el-option>
								<el-option label="威龙 - 吴彦祖" value="5"></el-option>
								<el-option label="蜂医 - 送葬人" value="6"></el-option>
								<el-option label="蜂医 - 黑鹰坠落" value="7"></el-option>
								<el-option label="蜂医 - 危险物质" value="8"></el-option>
								<el-option label="无名 - 夜鹰" value="9"></el-option>
								<el-option label="乌鲁售・黑鹰坠落" value="10"></el-option>
								<el-option label="牧羊人 - 黑鹰坠落" value="11"></el-option>
								<el-option label="牧羊人 - 街头之王" value="12"></el-option>
								<el-option label="露娜 - 黑 - 天际线" value="13"></el-option>
								<el-option label="蛊 - 能天使 - 午夜邮差" value="14"></el-option>
								<el-option label="骇爪 - 维什戴尔" value="15"></el-option>
								<el-option label="骇爪 - 水墨云图" value="16"></el-option>
								<el-option label="露娜 - 金牌射手" value="17"></el-option>
								<el-option label="深蓝 - 不破之誓" value="18"></el-option>
								<el-option label="红狼 - 电锯惊魂" value="19"></el-option>
								<el-option label="威龙 - 凌霄戍卫" value="20"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :span="12">
						<el-form-item label="刀皮">
							<el-select multiple v-model="form.daopi" placeholder="刀皮" style="width: 100%;">
								<el-option label="信条" value="1"></el-option>
								<el-option label="赤霄" value="2"></el-option>
								<el-option label="怜悯" value="3"></el-option>
								<el-option label="影锋" value="4"></el-option>
								<el-option label="黑海" value="5"></el-option>
								<el-option label="北极星" value="6"></el-option>
								<el-option label="电锯惊魂" value="7"></el-option>
								<el-option label="龙牙" value="8"></el-option>
								<el-option label="暗星" value="9"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="武器皮">
							<el-select multiple v-model="form.wuqi" placeholder="武器皮" style="width: 100%;">
								<el-option label="M7 棱镜攻势" value="1"></el-option>
								<el-option label="M4 棱镜攻势" value="2"></el-option>
								<el-option label="K416 - 命运" value="3"></el-option>
								<el-option label="SCAR - 电玩" value="4"></el-option>
								<el-option label="腾龙 - 气象感应" value="5"></el-option>
								<el-option label="QBZ95 - 王牌之剑" value="6"></el-option>
								<el-option label="Vctor - 中锋枪 - 美杜莎" value="7"></el-option>
								<el-option label="AS Val 突击步枪 - 悬赏令" value="8"></el-option>
								<el-option label="AUG - 气象感应" value="9"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :span="6">
						<el-form-item label="AWM子弹">
							<el-input v-model="form.awm" placeholder="AWM子弹" style="width: 100%;"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="六套数量">
							<el-input v-model="form.liutao" placeholder="0-60" style="width: 100%;"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="比例">
							<el-input v-model="form.bili" placeholder="比例" style="width: 100%;" @input="calculateEditPrice('bili')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="价格(元)">
							<el-input v-model="form.price" placeholder="租金" style="width: 100%;" @input="calculateEditPrice('price')"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :span="6">
						<el-form-item label="押金(元)">
							<el-input v-model="form.yajin" placeholder="押金" style="width: 100%;"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="IP地址">
							<el-input v-model="form.changzhu" placeholder="IP地址" style="width: 100%;"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="KD">
							<el-input v-model="form.kd" placeholder="KD" style="width: 100%;"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="租期(天)">
							<el-input v-model="form.zuqi" placeholder="租期" style="width: 100%;"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :span="24">
						<el-form-item label="备注">
							<el-input type="textarea" v-model="form.beizhu" placeholder="备注" style="width: 100%;"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button style="background: #f5f5f5; border-color: #d9d9d9; color: #333; border-radius: 3px;"
					@click="dialogVisible = false">取消</el-button>
				<el-button style="background: #1f9535; border-color: #1f9535; color: #fff; border-radius: 3px;"
					@click="saveEdit">保存</el-button>
			</div>
		</el-dialog>

		<el-dialog title="选择删除原因" :visible.sync="deleteReasonDialogVisible" width="500px" :close-on-click-modal="false">
			<el-radio-group v-model="deleteReasonForm.reason_type">
				<el-radio label="yishouchu">已售出</el-radio>
				<el-radio label="fabucuowu">账号发布错误</el-radio>
				<el-radio label="linshixiajia">临时下架/删除</el-radio>
				<el-radio label="haozhubuchule">号主不出了</el-radio>
				<el-radio label="keful_beihaozhushanchu">客服被号主删除</el-radio>
				<el-radio label="haozhulianxibushang">号主联系不上</el-radio>
			</el-radio-group>
			<div slot="footer" class="dialog-footer">
				<el-button @click="deleteReasonDialogVisible = false">取消</el-button>
				<el-button type="primary" @click="confirmDelete">确定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="选择下架原因" :visible.sync="pulloffReasonDialogVisible" width="500px" :close-on-click-modal="false">
			<el-radio-group v-model="pulloffReasonForm.reason_type">
				<el-radio label="yishouchu">已售出</el-radio>
				<el-radio label="fabucuowu">账号发布错误</el-radio>
				<el-radio label="linshixiajia">临时下架/删除</el-radio>
				<el-radio label="haozhubuchule">号主不出了</el-radio>
				<el-radio label="keful_beihaozhushanchu">客服被号主删除</el-radio>
				<el-radio label="haozhulianxibushang">号主联系不上</el-radio>
			</el-radio-group>
			<div slot="footer" class="dialog-footer">
				<el-button @click="pulloffReasonDialogVisible = false">取消</el-button>
				<el-button type="primary" @click="confirmSuspend">确定</el-button>
			</div>
		</el-dialog>
	</div>

</template>
<script>
import { getFilterTitleByValue, filterFallbackMap } from '@/utils/filterMap.js';
	export default {
		data() {
			return {
				query: [],
				daqu_list: [],
				server_list: [],
				server_show: false,
				channel: 30,
				daqu: 0,
				fuwuqi: 0,
				order: 1,
				flowList: [],
				expandState: {},
				filter_chose: [],
				filterlist: [],
				fbeifen: [],
				channeldata: [],
				current_page: 1,
				pagesize: 20,
				total: 0,
				last_page: 0,
				filter: {
					strprice: '',
					endprice: '',
				},
				loadStatus: 'loadmore',
				strprice: '',
				endprice: '',
				keyword: '',
				sortactive: 1,
				sort: 0,
				is_zu: 0,
				acc_type: "1",
				loading: true,
				windowWidth: window.innerWidth,
				showCompactView: false,
				showNightShift: false,
				showADCode: false,
				showBHCode: false,
				clickCount: {},
			boundKefuCodes: [],
			priceindex: -1,
				q: "",
				pricelist: [{
						min: 500,
						max: 4999
					},
					{
						min: 5000,
						max: 9999
					},
					{
						min: 10000,
						max: 14999
					},
					{
						min: 15000,
						max: 19999
					},
					{
						min: 20000,
						max: 9999999
					}
				],
				channellist: [],
				flag: [],
				show_list: {},
				first: true,
				show_filter: true,
				show_filter2: false,
				show_filter_index: 0,
				tempFilterValues: {},
				show_filter_content: {},
				show_filter_selects: {},
				mo_index: 0,
				image_show: false,
				img_src: '',
				mobileFilterExpanded: false,
				publishForm: {
					kefu_id: '',
					login_type: '',
					is_feng: '1',
					is_ben: '1',
					level: '60',
					zichan: '',
					chunbi: '',
					box: '',
					xunlian: '',
					bachang: '',
					kd: '',
					duanwei: '',
					ganyuan: [],
					daopi: [],
					wuqi: [],
					awm: '',
					liutao: '',
					bili: '',
					price: '',
					yajin: '300',
					qufu: '',
					changzhu: '',
					zuqi: '',
					beizhu: ''
				},
				kefuList: [],
				lastKefuId: null,
				publishLock: false,
				lastPublishTime: 0,
				lastPublishAccountNo: '',
				kefuDialogVisible: false,
				deleteReasonDialogVisible: false,
				pulloffReasonDialogVisible: false,
				deleteReasonForm: {
					accountId: '',
					reason_type: ''
				},
				pulloffReasonForm: {
					accountId: '',
					reason_type: ''
				},
				currentKefuInfo: null,
				currentAccountNo: '',
				chazhiCache: 0,
				dialogVisible: false,
				form: {
					id: '',
					kefu_id: '',
					login_type: '',
					is_feng: '',
					is_ben: '',
					level: '',
					zichan: '',
					chunbi: '',
					box: '',
					xunlian: '',
					bachang: '',
					kd: '',
					duanwei: '',
					ganyuan: [],
					daopi: [],
					wuqi: [],
					awm: '',
					liutao: '',
					bili: '',
					price: '',
					yajin: '',
					qufu: '',
					changzhu: '',
					changzhu_text: '',
					zuqi: '',
					beizhu: ''
				}


			}
		},
		computed: {

			activeKefuList() {
				return this.kefuList.filter(k => k.status == 1)
			},

			login() {
				return this.$store.getters.login
			},
			open_login() {
				return this.$store.getters.open_login
			},

			isMobile() {
				return this.$store.getters.isMobile
			},
			gamelist() {
				return this.$store.getters.gamelist
			},
			allGameList() {
				return this.$store.getters.allGameList
			},
			config() {
				return this.$store.getters.config
			},
			userinfo() {
				return this.$store.getters.userinfo
			},
			isAdmin() {
				return this.$store.getters.isAdmin
			},
			isCompactView() {
				return this.isAdmin && this.showCompactView && this.windowWidth < 1400;
			},
			isNightShift() {
				return this.showNightShift;
			},
			hasBoundKefu() {
				return this.isAdmin && this.boundKefuCodes && this.boundKefuCodes.length > 0;
			}
		},
		created() {
			this.filter_chose2 = []
			this.keyword = this.$route.query.keyword;
			this.channel = 30;
			this.getchannellist(this.$data.channel);
			this.addRandomData(this.$data.channel, this.$data.current_page, this.$data.pagesize);
			this.getKefuList();
			
			window.addEventListener('resize', this.handleResize);
			this.handleResize();
			this.$store.dispatch('getBackupModeConfig');
			this.rq.requests.post('api/game/hall/getChazhiConfig').then(res => {
				if (res.code === 1 && res.data) {
					this.chazhiCache = parseFloat(res.data.chazhi) || 0
				}
			})
			this.getBoundKefuCodes();
		},
		watch: {
			// isAdmin(val) {
			// 	if (val) {
			// 		this.getBoundKefuCodes();
			// 	}
			// },
			$route() {
				this.$data.keyword = this.$route.query.keyword;
				this.$data.current_page = 1;
				this.$data.pagesize = 20;
				this.addRandomData(this.$data.channel, this.$data.current_page, this.$data.pagesize);
			},
			showNightShift(val) {
				if (val) {
					this.showADCode = false;
					this.showBHCode = false;
				}
				this.current_page = 1;
				this.addRandomData(this.channel, this.current_page, this.pagesize);
			},
			showADCode(val) {
				if (val) {
					this.showNightShift = false;
					this.showBHCode = false;
				}
				this.current_page = 1;
				this.addRandomData(this.channel, this.current_page, this.pagesize);
			},
			showBHCode(val) {
				if (val) {
					this.showNightShift = false;
					this.showADCode = false;
				}
				this.current_page = 1;
				this.addRandomData(this.channel, this.current_page, this.pagesize);
			}
		},
		methods: {
			getTimeClass(item) {
				if (!item || !item.updatetime) return '';
				const now = new Date().getTime();
				const backupModeEnabled = this.$store.state.backupModeEnabled;
				const timeRange = this.$store.state.backupTimeRange || '24h';
				const rangeMap = {
					'1h': 1,
					'3h': 3,
					'6h': 6,
					'24h': 24,
					'72h': 72,
					'7d': 168
				};
				const backupOffset = backupModeEnabled ? (rangeMap[timeRange] || 24) * 60 * 60 * 1000 : 0;
				const updateTime = new Date(item.updatetime * 1000).getTime() + backupOffset;
				const diffHours = (now - updateTime) / (1000 * 60 * 60);
				
				if (diffHours > 168) return 'time-orange';
				if (diffHours > 72) return 'time-yellow';
				if (diffHours > 24) return 'time-blue';
				return '';
			},
			getCellClassName({ row, column, rowIndex, columnIndex }) {
				return '';
			},
			cellStyle({ row, column, rowIndex, columnIndex }) {
				if (columnIndex === 0) {
					const timeClass = this.getTimeClass(row);
					if (timeClass === 'time-blue') return { color: '#1890ff' };
					if (timeClass === 'time-yellow') return { color: '#faad14' };
					if (timeClass === 'time-orange') return { color: '#ff4d4f' };
				}
				return {};
			},
			getTimeClassForStyle(item) {
				const timeClass = this.getTimeClass(item);
				if (timeClass === 'time-blue') return { color: '#1890ff' };
				if (timeClass === 'time-yellow') return { color: '#faad14' };
				if (timeClass === 'time-orange') return { color: '#ff4d4f' };
				return { color: '' };
			},
			isNightShiftAccount(row) {
				if (!row) return false;
				const accountNo = row.account_no || row.id;
				return accountNo && accountNo.toString().startsWith('E');
			},
			toggleNightShift() {
				this.showNightShift = !this.showNightShift;
				if (this.showNightShift) {
					this.showADCode = false;
					this.showBHCode = false;
				}
				this.current_page = 1;
				this.addRandomData(this.channel, this.current_page, this.pagesize);
			},
			toggleADCode() {
				this.showADCode = !this.showADCode;
				if (this.showADCode) {
					this.showNightShift = false;
					this.showBHCode = false;
				}
				this.current_page = 1;
				this.addRandomData(this.channel, this.current_page, this.pagesize);
			},
			toggleBHCode() {
				this.showBHCode = !this.showBHCode;
				if (this.showBHCode) {
					this.showNightShift = false;
					this.showADCode = false;
				}
				this.current_page = 1;
				this.addRandomData(this.channel, this.current_page, this.pagesize);
			},
			isBoundKefu(accountNo) {
				if (!this.isAdmin || !this.hasBoundKefu || !accountNo) {
					return false;
				}
				const prefix = accountNo.charAt(0);
				return this.boundKefuCodes.includes(prefix);
			},
			handleResize() {
				this.windowWidth = window.innerWidth;
			},
			getKefuList() {
				this.rq.requests.post('api/game/hall/getKefuAll').then(res => {
					if (res.code === 1) {
						this.kefuList = res.data || []
					}
				}).catch(err => {
					console.error('getKefuAll error:', err)
				})
			},
			getBoundKefuCodes() {
				this.rq.requests.post('api/game/hall/getBoundKefuCodes').then(res => {
					if (res.code === 1 && res.data) {
						this.boundKefuCodes = res.data || []
					}
				}).catch(err => {
					console.error('getBoundKefuCodes error:', err)
				})
			},
			handleKefuChange(value) {
				this.publishForm.kefu_id = value
				this.rq.requests.post('api/game/hall/getChazhiConfig').then(res => {
					if (res.code === 1 && res.data) {
						this.chazhiCache = parseFloat(res.data.chazhi) || 0
					}
				})
			},
			copyAccountNo(accountNo) {
				const text = accountNo || '';
				if (text) {
					navigator.clipboard.writeText(text).then(() => {
						this.$message.success('复制成功：' + text);
					}).catch(() => {
						this.$message.error('复制失败');
					});
				}
			},
			goToDetail(row) {
				window.location.href = '/goodsdetail?id=' + row.id
			},
			toggleExpand(id, field) {
				const key = id + '_' + field
				this.$set(this.expandState, key, !this.expandState[key])
			},
			toggleMobileFilterExpand() {
				this.mobileFilterExpanded = !this.mobileFilterExpanded
			},
			getKefuList() {
				this.rq.requests.post('api/game/hall/getKefuAll').then(res => {
					if (res.code === 1) {
						this.kefuList = res.data || []
					}
				}).catch(err => {
					console.error('getKefuAll error:', err)
				})
			},
			getBoundKefuCodes() {
				this.rq.requests.post('api/game/hall/getBoundKefuCodes').then(res => {
					if (res.code === 1 && res.data) {
						this.boundKefuCodes = res.data || []
					}
				}).catch(err => {
					console.error('getBoundKefuCodes error:', err)
				})
			},

			handleKefuChange(value) {
				this.publishForm.kefu_id = value
				this.rq.requests.post('api/game/hall/getChazhiConfig').then(res => {
					if (res.code === 1 && res.data) {
						this.chazhiCache = parseFloat(res.data.chazhi) || 0
					}
				})
			},
			openKefuDialog(row) {
				if (row && (row.kefu_name || row.kefu_wechat || row.kefu_qrcode || row.kefu_id)) {
					if (row.kefu_name || row.kefu_wechat || row.kefu_qrcode) {
						this.currentKefuInfo = {
							name: row.kefu_name || '',
							wechat: row.kefu_wechat || '',
							qrcode: row.kefu_qrcode || ''
						}
						this.currentAccountNo = row.account_no || '暂无编号'
						this.kefuDialogVisible = true
						return
					}
					let kefu = this.kefuList.find(k => k.id === row.kefu_id)
					if (!kefu) {
						this.rq.requests.post('api/game/hall/getKefuAll').then(res => {
							this.kefuList = res.data || []
							kefu = this.kefuList.find(k => k.id === row.kefu_id)
							if (kefu) {
								this.currentKefuInfo = kefu
								this.currentAccountNo = row.account_no || '暂无编号'
								this.kefuDialogVisible = true
							} else {
								this.$message.warning('该账号未绑定客服')
							}
						}).catch(() => {
							this.$message.warning('获取客服信息失败')
						})
						return
					}
					if (kefu) {
						this.currentKefuInfo = kefu
						this.currentAccountNo = row.account_no || '暂无编号'
						this.kefuDialogVisible = true
					} else {
						this.$message.warning('该账号未绑定客服')
					}
				} else {
					this.$message.warning('该账号未绑定客服')
				}
			},
			closeKefuDialog() {
				this.kefuDialogVisible = false
			},

			openShowImg(img) {
				this.img_src = img
				this.image_show = true
			},

			choseFilterselects(data, item) {

				const filterKey = data.name;
				// 1. 容错：如果 show_filter_selects[filterKey] 不存在，先初始化（关键！保证响应式）
				if (!this.show_filter_selects[filterKey]) {
					this.$set(this.show_filter_selects, filterKey, {
						value: [],
						title: []
					});
				}

				// 2. 取出数组（确保是响应式数组）
				const valueArray = this.show_filter_selects[filterKey].value;
				const valueArray2 = this.show_filter_selects[filterKey].title;
				const targetValue = item.value;
				const targetValue2 = item.title;

				// 3. 安全校验：确保是数组（避免调用 includes/splice 报错）
				if (!Array.isArray(valueArray) || !Array.isArray(valueArray2)) {
					this.$set(this.show_filter_selects[filterKey], 'value', []);
					this.$set(this.show_filter_selects[filterKey], 'title', []);
					return; // 初始化后退出，避免后续操作报错
				}

				// 4. 增删逻辑（splice/push 是 Vue2 支持的响应式数组方法）
				if (valueArray.includes(targetValue)) {
					const valIndex = valueArray.indexOf(targetValue);
					const titleIndex = valueArray2.indexOf(targetValue2);
					// 移除时要判断索引有效（避免 -1 导致删除最后一个元素）
					if (valIndex > -1) valueArray.splice(valIndex, 1);
					if (titleIndex > -1) valueArray2.splice(titleIndex, 1);
				} else {
					valueArray.push(targetValue);
					valueArray2.push(targetValue2);
				}



			},

			choseFilterItem2(item) {
				for (let i = 0; i < this.filter_chose.length; i++) {
					if (this.filter_chose[i].name == item.name) {
						this.filter_chose[i].value = [];
						this.filter_chose[i].value = this.show_filter_selects[item.name].value;
						this.filter_chose[i].show_title = this.show_filter_selects[item.name].title.join('/');;
						this.show_filter2 = false
						this.current_page = 1;
						this.pagesize = 20;
						this.addRandomData(this.channel, this.current_page, this.pagesize);
					}
				}
			},

			//获取状态
			getItemActive(data, item) {
				const tempValues = this.tempFilterValues[data.name];
				const hasTemp = tempValues && tempValues.length > 0;
				if (hasTemp) {
					return tempValues.includes(item.value);
				}
				const filterItem = this.filter_chose.find(f => f.name === data.name);
				const hasChosen = filterItem && filterItem.value && filterItem.value.length > 0;
				if (hasChosen) {
					return filterItem.value.includes(item.value);
				}
				return false;
			},
			//清空筛选
			removefilter(i) {
				this.filter_chose[i].value = [];
				this.filter_chose[i].show_title = '';
				this.current_page = 1;
				this.pagesize = 20;
				this.addRandomData(this.channel, this.current_page, this.pagesize);
			},
			//清空筛选
			removefilter2(i, name) {
				this.$set(this.show_filter_selects, name, {
					value: [],
					title: []
				});

				this.filter_chose[i].value = [];

				this.filter_chose[i].show_title = '';
				this.current_page = 1;
				this.pagesize = 20;
				this.addRandomData(this.channel, this.current_page, this.pagesize);
			},
			showfilter(index, item) {
				if (this.show_filter2 && this.show_filter_index === index) {
					this.show_filter2 = false
				} else if (this.filter_chose[index].show_title !== '') {
					this.filter_chose[index].value = []
					this.filter_chose[index].show_title = ''
					this.show_filter2 = false
					this.current_page = 1
					this.pagesize = 20
					this.addRandomData(this.channel, this.current_page, this.pagesize)
				} else {
					this.show_filter_index = index
					this.show_filter2 = true
					this.show_filter_content = item
					const existingValue = this.filter_chose[index] && this.filter_chose[index].value ? [...this.filter_chose[index].value] : [];
					this.$set(this.tempFilterValues, item.name, existingValue);
				}
			},


			choseFilterItem(item, data) {
				if (item.type != 'selects') {
					if (!this.tempFilterValues[item.name]) {
						this.$set(this.tempFilterValues, item.name, []);
					}
					const currentValues = this.tempFilterValues[item.name];
					const idx = currentValues.indexOf(data.value);
					if (idx > -1) {
						currentValues.splice(idx, 1);
					} else {
						currentValues.push(data.value);
					}
				}

			},
			/**
			 * 去除时间字符串中的时分秒，只保留年月日
			 * @param {string} timeStr - 包含时分秒的时间字符串，如 "2026-01-15 16:20:31"
			 * @returns {string} 只保留年月日的字符串，如 "2026-01-15"
			 */
			formatDateToYmd(timeStr) {
				// 先判断输入是否有效，避免报错
				if (!timeStr || typeof timeStr !== 'string') {
					return ''; // 或返回默认值，如 '1970-01-01'
				}
				// 按空格分割，取第一个部分（年月日）
				return timeStr.split(' ')[0];
			},
			confirmFilter() {
				const index = this.show_filter_index;
				const item = this.show_filter_content;
				if (!item || !item.name) return;
				
				const tempValues = this.tempFilterValues[item.name] || [];
				if (tempValues.length === 0) {
					this.filter_chose[index].value = [];
					this.filter_chose[index].show_title = '';
				} else {
					this.filter_chose[index].value = tempValues;
					const titles = tempValues.map(v => {
						const opt = (item.content || []).find(c => c.value == v);
						return opt ? opt.title : v;
					}).join(',');
					this.filter_chose[index].show_title = titles;
				}
				
				this.show_filter2 = false;
				this.current_page = 1;
				this.pagesize = 20;
				this.addRandomData(this.channel, this.current_page, this.pagesize);
			},
			getFilterTitleByValue(fieldName, fieldValue) {
				if (!fieldName || !fieldValue) return '';
				
				const filter = this.filterlist.find(f => f.name === fieldName);
				if (!filter || !filter.content) return fieldValue;
				
				const option = filter.content.find(c => c.value == fieldValue);
				return option ? option.title : fieldValue;
			},
			clearAllFilters() {
				for (let i = 0; i < this.filter_chose.length; i++) {
					this.filter_chose[i].value = [];
					this.filter_chose[i].show_title = '';
				}
				this.tempFilterValues = {};
				this.show_filter2 = false;
				this.mobileFilterExpanded = false;
				this.current_page = 1;
				this.pagesize = 20;
				this.addRandomData(this.channel, this.current_page, this.pagesize);
			},
			Search() {
				this.current_page = 1;
				this.pagesize = 20;
				this.addRandomData(this.channel, this.current_page, this.pagesize);
			},
			openShow(name) {
				this.show_filter = false
				this.show_list[name].show = !this.show_list[name].show
				this.show_filter = true
			},
			choseFilter(index, value) {


				var type = this.filterlist[index].type

				if (value == '') {
					this.filter_chose[index].value = [value];
					this.current_page = 1;
					this.pagesize = 20;
					this.addRandomData(this.channel, this.current_page, this.pagesize);
					return;
				}

				if (type == 'selects') {
					if (value != '') {
						let res = this.filter_chose[index].value.indexOf('');

						if (res !== -1) {
							// 存在则删除该值
							this.filter_chose[index].value.splice(res, 1);
						}
					}

					let res = this.filter_chose[index].value.indexOf(value);
					if (res !== -1) {
						// 存在则删除该值
						this.filter_chose[index].value.splice(res, 1);
					} else {
						// 不存在则添加该值
						this.filter_chose[index].value.push(value);
					}
				} else {
					this.filter_chose[index].value = [];
					this.filter_chose[index].value = [value];
				}

				this.current_page = 1;
				this.pagesize = 20;
				this.addRandomData(this.channel, this.current_page, this.pagesize);
			},

			chose_sort(index, sort) {
				if (this.sortactive === index && this.clickCount[index]) {
					this.clickCount[index]++;
					if (this.clickCount[index] >= 3) {
						this.sortactive = 1;
						this.sort = 0;
						this.clickCount = {};
						this.current_page = 1;
						this.addRandomData(this.channel, this.current_page, this.pagesize);
						return;
					}
				} else {
					this.clickCount = {};
					this.clickCount[index] = 1;
				}

				this.sortactive = index;

				if (sort == 0) {
					this.sort = 1
				} else {
					this.sort = 0
				}



				this.$data.current_page = 1;
				this.addRandomData(this.$data.channel, this.$data.current_page, this.$data.pagesize);


			},

			getchannellist(id) {
				this.rq.requests.post("/api/game/Hall/getchannellist", {
					id: id,

				}).then(res => {

					this.channellist = res.data;
				}).catch(error => {

				})
			},




			addRandomData(id, current_page, pagesize) {
				this.loading = true;
				this.expandState = {};
				var that = this;
				var filter = {};
				filter = this.$data.filter;
				filter.q = this.$data.key;



				filter.filter_chose = that.filter_chose,

					filter = JSON.stringify(filter);
				filter = encodeURIComponent(filter);




				this.rq.requests.post("api/game/hall/getCarchives", {
					id: id,
					daqu: that.daqu,
					fuwuqi: that.fuwuqi,
					page: current_page,
					filter: filter,
					order: that.sortactive,
					order_num: that.sort,
					pagesize: pagesize,
					keyword: that.keyword,
					nightShift: that.showNightShift ? 1 : 0,
					adCode: that.showADCode ? 1 : 0,
					bhCode: that.showBHCode ? 1 : 0,

				}).then(res => {
					that.last_page = res.data.list.last_page;

					const newFilterChose = res.data.filter;
					that.filterlist = res.data.filterlist;
					
					if (that.filterlist && that.filterlist.length > 0) {
						for (let i = 0; i < newFilterChose.length; i++) {
							const item = newFilterChose[i];
							if (item && item.name && item.value && item.value.length > 0 && (!item.show_title || item.show_title === '')) {
								const values = item.value.filter(v => v !== '');
								if (values.length > 0) {
									item.show_title = values.map(v => getFilterTitleByValue(item.name, v, that.filterlist)).join(',');
								}
							}
						}
					}
					
					for (let i = 0; i < that.filter_chose.length; i++) {
						const localItem = that.filter_chose[i];
						if (localItem && localItem.name && localItem.value && localItem.value.length > 0) {
							const newItemIndex = newFilterChose.findIndex(f => f.name === localItem.name);
							if (newItemIndex !== -1) {
								if (!newFilterChose[newItemIndex].show_title || newFilterChose[newItemIndex].show_title === '') {
									newFilterChose[newItemIndex] = localItem;
								}
							}
						}
					}
					
					that.filter_chose = newFilterChose;
					that.current_page = res.data.list.current_page;
					that.total = res.data.list.total;

					for (let i = 0; i < that.filterlist.length; i++) {

						if (!that.show_list[that.filterlist[i].name]) {
							that.show_list[that.filterlist[i].name] = {
								show: that.filterlist[i].show,
								extend: that.filterlist[i].extend

							};


						}
					}




					that.flowList = res.data.list.data;

					for (let index = 0; index < that.flowList.length; index++) {
						that.flowList[index].show = false;
					}
					that.loading = false
					that.flag = res.data.flag;

				}).catch(error => {

				})
			},

			handleSizeChange(val) {

				this.pagesize = val;
				this.current_page = 1;
				this.addRandomData(this.$data.channel, 1, val);
			},
			handleCurrentChange(val) {
				this.current_page = val;
				this.addRandomData(this.$data.channel, val, this.$data.pagesize);
			},
			strpricechange() {

				this.addRandomData(this.$data.channel, this.$data.current_page, this.$data.pagesize);
			},
			endpricechange() {
				this.addRandomData(this.$data.channel, this.$data.current_page, this.$data.pagesize);
			},
			//选择大区
			daquchange(value) {

				if (value.id == 0) {
					this.server_list = [];

				} else {
					this.server_list = value.childlist
				}

				this.fuwuqi = 0;

				this.daqu = value.id;
				this.current_page = 1;
				this.addRandomData(this.$data.channel, this.$data.current_page, this.$data.pagesize);


			},
			//选择服务器
			fuwqichange(value) {

				this.fuwuqi = value.id;
				this.current_page = 1;
				this.addRandomData(this.$data.channel, this.$data.current_page, this.$data.pagesize);
			},
			show(index) {

				this.flowList[index].show = !this.flowList[index].show
				this.mo_index++

			},

			getFilterName(value, num) {

				for (let i = 0; i < this.filterlist.length; i++) {
					if (this.filterlist[i].name == value) {

						for (let a = 0; a < this.filterlist[i].content.length; a++) {

							if (num == this.filterlist[i].content[a].value) {
								return this.filterlist[i].content[a].title

							}
						}
					}
				}
			},
			getFilterNameList(fieldName, valueStr) {
				// 1. 处理空值情况
				if (!valueStr || valueStr.trim() === '') {
					return ''; // 无值时返回"全部"
				}

				// 2. 备用映射表 - 完整的选项映射
				const fallbackMap = {
					daopi: {
						1: '信条',
						2: '赤霄',
						3: '怜悯',
						4: '影锋',
						5: '黑海',
						6: '北极星',
						7: '电锯惊魂',
						8: '龙牙',
						9: '暗星'
					},
					ganyuan: {
						1: '红狼 - 蚀金玫瑰',
						2: '红狼 - 黑鹰坠落',
						3: '威龙 - 蛟龙行动',
						4: '威龙 - 铁面判官',
						5: '威龙 - 吴彦祖',
						6: '蜂医 - 送葬人',
						7: '蜂医 - 黑鹰坠落',
						8: '蜂医 - 危险物质',
						9: '无名 - 夜鹰',
						10: '乌鲁售・黑鹰坠落',
						11: '牧羊人 - 黑鹰坠落',
						12: '牧羊人 - 街头之王',
						13: '露娜 - 黑 - 天际线',
						14: '蛊 - 能天使 - 午夜邮差',
						15: '骇爪 - 维什戴尔',
						16: '骇爪 - 水墨云图',
						17: '露娜 - 金牌射手',
						18: '深蓝 - 不破之誓',
						19: '红狼 - 电锯惊魂',
						20: '威龙 - 凌霄戍卫'
					}
				};

				// 3. 如果有备用映射，直接使用
				if (fallbackMap[fieldName]) {
					const values = valueStr.split(',').map(val => parseInt(val));
					const titles = values.map(v => fallbackMap[fieldName][v] || v).filter(v => v);
					return titles.join(',');
				}

				// 4. 找到对应字段的数据项
				const fieldItem = this.filterlist.find(item => item.name === fieldName);
				if (!fieldItem) {
					return ''; // 字段不存在时返回空字符串
				}

				// 5. 拆分值字符串为数组，并处理类型转换（匹配数据中的value类型）
				const values = valueStr.split(',').map(val => {
					const numVal = Number(val);
					return isNaN(numVal) ? val : numVal;
				});

				// 6. 匹配对应的中文标题
				const titles = [];
				fieldItem.content.forEach(contentItem => {
					if (values.includes(contentItem.value)) {
						titles.push(contentItem.title);
					}
				});

				// 7. 如果匹配结果为空，尝试使用备用映射表
				if (titles.length === 0 && fallbackMap[fieldName]) {
					const numValues = valueStr.split(',').map(val => parseInt(val));
					return numValues.map(v => fallbackMap[fieldName][v] || v).filter(v => v).join(',');
				}

				// 8. 拼接并返回结果
				return titles.join(',');
			},
			publishAccount() {
				const now = Date.now();
				const timeDiff = now - this.lastPublishTime;

				if (this.publishLock && timeDiff < 5000) {
					this.$message.warning('操作过于频繁，请5秒后再试');
					return;
				}

				const missingFields = [];
				if (!this.publishForm.kefu_id) missingFields.push('客服');
				if (!this.publishForm.chunbi && this.publishForm.chunbi !== 0) missingFields.push('纯币数量');
				if (!this.publishForm.box && this.publishForm.box !== 0) missingFields.push('保险');
				if (!this.publishForm.xunlian && this.publishForm.xunlian !== 0) missingFields.push('训练等级');
				if (!this.publishForm.bachang && this.publishForm.bachang !== 0) missingFields.push('靶场等级');
				if (!this.publishForm.duanwei && this.publishForm.duanwei !== 0) missingFields.push('段位');
				if (!this.publishForm.bili && this.publishForm.bili !== 0) missingFields.push('比例');
				if (!this.publishForm.price && this.publishForm.price !== 0) missingFields.push('租金');
				if (!this.publishForm.yajin) missingFields.push('押金');
				if (!this.publishForm.zuqi && this.publishForm.zuqi !== 0) missingFields.push('租期');
				if (!this.publishForm.login_type && this.publishForm.login_type !== 0) missingFields.push('登录方式');

				if (missingFields.length > 0) {
					this.$message.warning('请填写以下必填项：' + missingFields.join('、'));
					return;
				}

				const xunlian = parseInt(this.publishForm.xunlian);
				if (isNaN(xunlian) || xunlian < 1 || xunlian > 7) {
					this.$message.warning('训练等级必须是1-7的数字');
					return;
				}

				const bachang = parseInt(this.publishForm.bachang);
				if (isNaN(bachang) || bachang < 1 || bachang > 7) {
					this.$message.warning('靶场等级必须是1-7的数字');
					return;
				}

				const bili = parseFloat(this.publishForm.bili);
				if (isNaN(bili) || bili <= 0) {
					this.$message.warning('比例必须是大于0的有效数字');
					return;
				}

				const zuqi = parseFloat(this.publishForm.zuqi);
				if (isNaN(zuqi) || zuqi <= 0) {
					this.$message.warning('租期必须是大于0的有效数字');
					return;
				}

				this.publishLock = true;
				this.lastPublishTime = now;

				const formData = Object.assign({}, this.publishForm);
				formData.xunlian = formData.xunlian ? String(formData.xunlian) : '';
				formData.bachang = formData.bachang ? String(formData.bachang) : '';

				this.rq.requests.post('api/game/hall/publish', formData).then(res => {
					this.$message.success('发布成功')
					this.addRandomData(this.$data.channel, this.$data.current_page, this.$data.pagesize);
					this.lastKefuId = this.publishForm.kefu_id;
					this.lastPublishAccountNo = res.data.account_no;
					this.publishForm = {
						kefu_id: this.lastKefuId || '',
						login_type: '',
						is_feng: '1',
						is_ben: '1',
						level: '60',
						zichan: '',
						chunbi: '',
						box: '',
						xunlian: '',
						bachang: '',
						kd: '',
						duanwei: '',
						ganyuan: [],
						daopi: [],
						wuqi: [],
						awm: '',
						liutao: '',
						bili: '',
						price: '',
						yajin: '300',
						qufu: '',
						changzhu: '',
						zuqi: '',
						beizhu: ''
					}
					setTimeout(() => {
						this.publishLock = false;
					}, 5000);
				}).catch(err => {
					this.publishLock = false;
					const errorMsg = err.data && err.data.msg ? err.data.msg : '发布失败，请稍后重试';
					this.$message.error(errorMsg);
				});
			},
			calculateRent() {
				const chazhi = this.chazhiCache
				const chunbi = parseFloat(this.publishForm.chunbi) || 0
				const bili = parseFloat(this.publishForm.bili) || 0
				if (chunbi > 0) {
					this.publishForm.zuqi = (chunbi / 10).toFixed(1);
				}
				if (chunbi > 0 && bili > 0) {
					const actualBili = bili - chazhi
					if (actualBili > 0) {
						this.publishForm.price = Math.round((chunbi / actualBili) * 100);
					}
				}
			},
			calculateEditPrice(source) {
				const chunbi = parseFloat(this.form.chunbi) || 0
				const bili = parseFloat(this.form.bili) || 0
				const price = parseFloat(this.form.price) || 0
				
				if (source === 'chunbi' || source === 'bili') {
					if (chunbi > 0 && bili > 0) {
						this.form.price = Math.round((chunbi / bili) * 100);
					}
				} else if (source === 'price') {
					if (chunbi > 0 && price > 0) {
						this.form.bili = Math.round((chunbi / price) * 100 * 10) / 10;
					}
				}
			},
			validateXunlianInput() {
				let val = parseInt(this.publishForm.xunlian) || 0;
				if (val < 1) val = 1;
				if (val > 7) val = 7;
				this.publishForm.xunlian = val;
			},
			validateBachangInput() {
				let val = parseInt(this.publishForm.bachang) || 0;
				if (val < 1) val = 1;
				if (val > 7) val = 7;
				this.publishForm.bachang = val;
			},
			editAccount(item) {
				// 打开编辑对话框
				this.dialogVisible = true
				this.form = Object.assign({}, item)
				if (this.form.daopi && typeof this.form.daopi === 'string') {
					this.form.daopi = this.form.daopi ? this.form.daopi.split(',') : []
				}
				if (this.form.wuqi && typeof this.form.wuqi === 'string') {
					this.form.wuqi = this.form.wuqi ? this.form.wuqi.split(',') : []
				}
				if (this.form.ganyuan && typeof this.form.ganyuan === 'string') {
					this.form.ganyuan = this.form.ganyuan ? this.form.ganyuan.split(',') : []
				}
				const changzhuMap = {
					1: '北京', 2: '天津', 3: '河北', 4: '山西', 5: '内蒙古', 6: '辽宁', 7: '吉林', 8: '黑龙江',
					9: '上海', 10: '江苏', 11: '浙江', 12: '安徽', 13: '福建', 14: '江西', 15: '山东', 16: '河南',
					17: '湖北', 18: '湖南', 19: '广东', 20: '广西', 21: '海南', 22: '重庆', 23: '四川', 24: '贵州',
					25: '云南', 26: '西藏', 27: '陕西', 28: '甘肃', 29: '青海', 30: '宁夏', 31: '新疆', 32: '台湾',
					33: '香港', 34: '澳门'
				}
				this.form.changzhu_text = changzhuMap[this.form.changzhu] || ''
			},
			deleteAccount(id) {
				this.deleteReasonForm.accountId = id
				this.deleteReasonForm.reason_type = ''
				this.deleteReasonDialogVisible = true
			},
			confirmDelete() {
				if (!this.deleteReasonForm.reason_type) {
					this.$message.warning('请选择删除原因')
					return
				}
				this.rq.requests.post('api/game/hall/deleteAccount', {
					id: this.deleteReasonForm.accountId,
					reason: this.getReasonText(this.deleteReasonForm.reason_type),
					reason_type: this.deleteReasonForm.reason_type
				}).then(res => {
					if (res.code === 1) {
						this.$message.success(res.msg || '删除成功')
						this.deleteReasonDialogVisible = false
						this.addRandomData(this.$data.channel, this.$data.current_page, this.$data.pagesize);
					} else {
						this.$message.error(res.msg || '删除失败')
					}
				}).catch(err => {
					this.$message.error('删除请求失败')
				})
			},
			suspendAccount(id) {
				this.pulloffReasonForm.accountId = id
				this.pulloffReasonForm.reason_type = ''
				this.pulloffReasonDialogVisible = true
			},
			confirmSuspend() {
				if (!this.pulloffReasonForm.reason_type) {
					this.$message.warning('请选择下架原因')
					return
				}
				this.rq.requests.post('api/game/hall/suspendAccount', {
					id: this.pulloffReasonForm.accountId,
					reason: this.getReasonText(this.pulloffReasonForm.reason_type),
					reason_type: this.pulloffReasonForm.reason_type
				}).then(res => {
					if (res.code === 1) {
						this.$message.success(res.msg || '下架成功')
						this.pulloffReasonDialogVisible = false
						this.addRandomData(this.$data.channel, this.$data.current_page, this.$data.pagesize);
					} else {
						this.$message.error(res.msg || '下架失败')
					}
				}).catch(err => {
					this.$message.error('下架请求失败')
				})
			},
			getReasonText(type) {
				const reasonMap = {
					'yishouchu': '已售出',
					'fabucuowu': '账号发布错误',
					'linshixiajia': '临时下架/删除',
					'haozhubuchule': '号主不出了',
					'keful_beihaozhushanchu': '客服被号主删除',
					'haozhulianxibushang': '号主联系不上'
				}
				return reasonMap[type] || ''
			},
			saveEdit() {
				const formData = Object.assign({}, this.form)
				if (Array.isArray(formData.daopi)) {
					formData.daopi = formData.daopi.join(',')
				}
				if (Array.isArray(formData.wuqi)) {
					formData.wuqi = formData.wuqi.join(',')
				}
				if (Array.isArray(formData.ganyuan)) {
					formData.ganyuan = formData.ganyuan.join(',')
				}
				this.rq.requests.post('api/game/hall/updateAccount', formData).then(res => {
					this.$message.success('修改成功')
					this.dialogVisible = false
					this.addRandomData(this.$data.channel, this.$data.current_page, this.$data.pagesize);
				})
			}

		}
	}
</script>
<style>
	.zuhao .el-radio__input {
		display: flex !important;
		align-items: center;
	}

	.zuhao .el-radio__input.is-checked .el-radio__inner {
		border-color: #508aff;
		background: #508aff;
	}

	.zuhao .el-radio__input.is-checked+.el-radio__label {
		color: #508aff;
	}

	.duanwei-tag {
		display: inline-block;
		padding: 2px 8px;
		border-radius: 4px;
		font-size: 12px;
		font-weight: 500;
	}

	.duanwei-1 {
		background-color: #f1f1f1;
		color: #000;
	}

	.duanwei-2 {
		background-color: #f4e4de;
		color: #000;
	}

	.duanwei-3 {
		background-color: #dbe6ec;
		color: #000;
	}

	.duanwei-4 {
		background-color: #ffe78b;
		color: #000;
	}

	.duanwei-5 {
		background-color: #a6ddf6;
		color: #000;
	}

	.duanwei-6 {
		background-color: #508aff;
		color: #fff;
	}

	.duanwei-7 {
		background-color: #2f3640;
		color: #fff;
	}

	.duanwei-8 {
		background-color: #2bf59f;
		color: #000;
	}
</style>